































































import { Component, Vue } from "vue-property-decorator";
import homeBanner from "./components/homeBanner.vue";
import reasonCom from "./components/reasonCom.vue";
import engineDesc from "./components/engineDesc.vue";
import newGoOnline from "./components/newGoOnline.vue";
import bannerDesc from "./components/bannerDesc.vue";
import contactUs from "@/components/contactUs.vue";
import contactUsNew from "@/components/contactUsNew.vue";
import ContactInformation from "./components/contactInformation/indexCopy.vue";
import VideoSwicth from "./components/videoSwicth/index.vue";
import { getNewsList } from "@/req/homes";

@Component({
  components: {
    homeBanner,
    reasonCom,
    engineDesc,
    newGoOnline,
    bannerDesc,
    contactUs,
    contactUsNew,
    ContactInformation,
    VideoSwicth
  },
})
export default class Home extends Vue {
  public scrollTop = 0;
  public newsList = [];
  public toOpen(paths) {
    const routeUrl = this.$router.resolve({
      path: paths,
    });
    window.open(routeUrl.href, "_blank");
  }
  public toTop() {
    const that = this;
    const timer = setInterval(() => {
      const ispeed = Math.floor(-that.scrollTop / 5);
      document.documentElement.scrollTop = document.body.scrollTop =
        that.scrollTop + ispeed;
      if (document.documentElement.scrollTop < 0) {
        this.scrollTop = 0;
      }
      if (that.scrollTop === 0) {
        clearInterval(timer);
      }
    }, 16);
  }
  /**
   * detail
   */
  public detail(id) {
    window.open(`/news/detail?id=${id}`, "_blank");
  }
  /**
   * download
   */
  public download(id) {
    // 埋点
    const reg = /\/(\d+)/g
    const params = {
      name: 'buttonClick',
      type: 'track',
      uid: '',
      properities: {
        buttonName: '首页悬浮广告位',
        pageUrl: window.top.location.pathname.replace(reg, '') || '',
        pagename: '分包管理',
        nparams: '',
        webSource: window.location.origin,
      }
    }
    this.$burying(params)
    window.open(`https://www.huohucloud.com/`, "_blank");
  }

  /**
   * 获取新闻列表
   */
  public initNewsList() {
    const params = {
      page: 1,
      limit: 5,
    };
    getNewsList(params).then((res) => {
      this.newsList = res.data.data.map((item) => {
        item.created_at = this.$fn.showDate("M-D", item.created_at);
        return item;
      });
    });
  }
  public mounted() {
    this.initNewsList();
    this.toTop();
  }
}
